// this file contains hardcoded data, to be later read dynamically from the database

// from original meditation-player.tsx
// const audioUrls = {
//   "veiligheid-aarding": {
//     Dana: "https://www.dropbox.com/scl/fi/67d83r7v6oblwatodsb0d/HnH_Meditaties_Aarden_Dana.mp3?rlkey=togr0omz22l3cfboumrbc3jko&dl=1",
//     Leo: "https://www.dropbox.com/scl/fi/5tcq2eo80xv46f72y8hzl/HnH_Meditaties_Aarden_Leo.mp3?rlkey=tbnvdqeldjvoxyjoyr8bgdegt&dl=1",
//   },
//   "rust-minder-stress": {
//     Dana: "https://www.dropbox.com/scl/fi/gwszer7bpd3buf1gs946v/Korte_Meditatie_Aarden_Muziek.mp3?rlkey=94x6e3kiqwj5u5asj1khjn1ee&dl=1",
//     Leo: "https://www.dropbox.com/scl/fi/gwszer7bpd3buf1gs946v/Korte_Meditatie_Aarden_Muziek.mp3?rlkey=94x6e3kiqwj5u5asj1khjn1ee&dl=1",
//   },
// };

export const MEDITATIONS = [
  {
    title: 'Aarden & Verbinding',
    duration: '15 min',
    category: 'Veiligheid',
    imageUrl:
      'https://images.unsplash.com/photo-1506126613408-eca07ce68773?q=80&w=1200',
  },
  {
    title: 'Rust & Minder Stress',
    duration: '20 min',
    category: 'Rust',
    imageUrl:
      'https://images.unsplash.com/photo-1528164344705-47542687000d?q=80&w=1200',
  },
  {
    title: 'Verbinding',
    duration: '15 min',
    category: 'Verbinding',
    imageUrl:
      'https://images.unsplash.com/photo-1516714435131-44d6b64dc6a2?q=80&w=1200',
  },
  {
    title: 'Liefde',
    duration: '18 min',
    category: 'Liefde',
    imageUrl:
      'https://images.unsplash.com/photo-1518609878373-06d740f60d8b?q=80&w=1200',
  },
  {
    title: 'Beweging',
    duration: '12 min',
    category: 'Beweging',
    imageUrl:
      'https://images.unsplash.com/photo-1552196563-55cd4e45efb3?q=80&w=1200',
  },
  {
    title: 'Ontspanning',
    duration: '20 min',
    category: 'ontspanning',
    imageUrl:
      'https://images.unsplash.com/photo-1515377905703-c4788e51af15?q=80&w=1200',
  },
  {
    title: 'Energie',
    duration: '10 min',
    category: 'Energie',
    imageUrl:
      'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=1200',
  },
  {
    title: 'Zingeving',
    duration: '15 min',
    category: 'Zingeving',
    imageUrl:
      'https://images.unsplash.com/photo-1507238691740-187a5b1d37b8?q=80&w=1200',
  },
  {
    title: 'Slaap',
    duration: '25 min',
    category: 'Slaap',
    imageUrl:
      'https://images.unsplash.com/photo-1471560090527-d1af5e4e6eb6?q=80&w=1200',
  },
  {
    title: 'Vreugde & Plezier',
    duration: '12 min',
    category: 'Vreugde',
    imageUrl:
      'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?q=80&w=1200',
  },
  {
    title: 'Dankbaarheid',
    duration: '15 min',
    category: 'Dankbaarheid',
    imageUrl:
      'https://images.unsplash.com/photo-1519834785169-98be25ec3f84?q=80&w=1200',
  },
  {
    title: 'Terug naar het Nu',
    duration: '10 min',
    category: 'Mindfulness',
    imageUrl:
      'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?q=80&w=1200',
  },
];

export const DUMMY_TRANSCRIPT = `1
00:00:00,000 --> 00:00:05,000
Deze meditatie kan je helpen om je lichaam beter te

2
00:00:05,000 --> 00:00:10,000
voelen en onbewust te gronden, zodat je stevig met beide

3
00:00:10,000 --> 00:00:15,000
benen op de grond staat, weer terugkomt in dit moment

4
00:00:15,000 --> 00:00:20,000
en vanuit verbinding met jezelf weer verder kunt. Doe deze

5
00:00:20,000 --> 00:00:25,000
oefening bij voorkeur op blote voeten of met sokken aan.

6
00:00:25,000 --> 00:00:30,000
Ga staan of zitten in een gemakkelijke houding. En focus

7
00:00:30,000 --> 00:00:35,000
dan op je ademhaling. In door je neus en uit

8
00:00:35,000 --> 00:00:40,000
door je mond. En met elke inademing haal je je

9
00:00:40,000 --> 00:00:45,000
aandacht een beetje meer weg uit de buitenwereld. En verleg

10
00:00:45,000 --> 00:00:50,000
je deze meer en meer naar binnen in. En laat

11
00:00:50,000 --> 00:00:55,000
met elke uitademing meer en meer los wat je nu,

12
00:00:55,000 --> 00:01:00,000
in dit moment, niet dient. Daardoor krijgt je lichaam de

13
00:01:00,000 --> 00:01:05,000
kans om met elke ademhaling een beetje meer te ontspannen.

14
00:01:05,000 --> 00:01:10,000
Dus adem maar eens diep in. En uit. En doe

15
00:01:10,000 --> 00:01:15,000
dat nog maar een keer. In door je neus en

16
00:01:15,000 --> 00:01:20,000
uit door je mond. In en uit. En ga met

17
00:01:20,000 --> 00:01:25,000
je aandacht naar je hoofd. Breng je kin naar je

18
00:01:25,000 --> 00:01:30,000
borst. En draai je hoofd in een cirkelbeweging langzaam richting

19
00:01:30,000 --> 00:01:35,000
je rechter schouder. Naar achteren. Verder naar je linkerschouder. En

20
00:01:35,000 --> 00:01:40,000
weer naar voren. Met je kin naar je borst. En

21
00:01:40,000 --> 00:01:45,000
herhaal dit een paar keer in je eigen tempo. Je

22
00:01:45,000 --> 00:01:50,000
hoeft niet te forceren. Hou het rustig en wees vriendelijk

23
00:01:50,000 --> 00:01:55,000
voor je lichaam. En verander nu van richting. En draai

24
00:01:55,000 --> 00:02:00,000
je hoofd naar links. Naar achteren. Richting je rechterschouder. Kin

25
00:02:00,000 --> 00:02:05,000
op de borst. En doe dat nog maar een keer.

26
00:02:05,000 --> 00:02:10,000
En rol vervolgens even met je schouders. Naar voren. Naar

27
00:02:10,000 --> 00:02:15,000
achteren. Naar achteren. Naar achteren. Naar achteren. Naar achteren. Naar

28
00:02:15,000 --> 00:02:20,000
achteren. Naar achteren. En ook even de andere kant op.

29
00:02:20,000 --> 00:02:25,000
Hol je schouders maar naar achteren. En als je lichaam

30
00:02:25,000 --> 00:02:30,000
het toelaat, dan kun je ook de rest van je

31
00:02:30,000 --> 00:02:35,000
bovenlichaam een ronddraaiende beweging laten maken. In de vorm van

32
00:02:35,000 --> 00:02:40,000
een acht. Dus draai je bovenlichaam linksom. En vervolgens rechtsom.

33
00:02:40,000 --> 00:02:45,000
Dan weer linksom. En ga maar even zo door. En

34
00:02:45,000 --> 00:02:50,000
breng dan je lichaam weer tot stilstand. En word je

35
00:02:50,000 --> 00:02:55,000
bewust van je voeten op de vloer. En ga dan

36
00:02:55,000 --> 00:03:00,000
weer linksom. En vervolgens rechtsom. En vervolgens linksom. En vervolgens

37
00:03:00,000 --> 00:03:05,000
linksom. En vervolgens linksom. En vervolgens linksom. Danprised jaar ammer

38
00:03:05,000 --> 00:03:10,000
buiten. Helmaal terug. Vist, ow, licht in de moed. Elk

39
00:03:10,000 --> 00:03:15,000
onderdeel van je voet, overal met je handen en de

40
00:03:15,000 --> 00:03:20,000
tand op die maag. En dan word je weer linksom.

41
00:03:20,000 --> 00:03:25,000
Naar het midden. Naar achteren. Heel rustig. Dan weer terug

42
00:03:25,000 --> 00:03:30,000
naar het midden. En naar voren. Beweeg met aandacht. En

43
00:03:30,000 --> 00:03:35,000
van voren ga je via de bal van je voet

44
00:03:35,000 --> 00:03:40,000
weer naar het midden. En dan verder naar achteren. En

45
00:03:40,000 --> 00:03:45,000
weer terug. En stel je dan voor dat er vanuit

46
00:03:45,000 --> 00:03:50,000
je voeten een soort van boomwortels de aarde ingroeien. Misschien

47
00:03:50,000 --> 00:03:55,000
is dit één wortel of misschien zijn het er een

48
00:03:55,000 --> 00:04:00,000
heleboel. En laat die wortels maar dieper en dieper de

49
00:04:00,000 --> 00:04:05,000
aarde ingroeien. Voorbij zand en grind en stroompjes water. En

50
00:04:05,000 --> 00:04:10,000
hoe dieper jouw wortels de aarde ingroeien, hoe steviger en

51
00:04:10,000 --> 00:04:15,000
hoe meer gegrond jij je voelt. En dan bereiken jouw

52
00:04:15,000 --> 00:04:20,000
voetwortels het middelpunt van de aarde. En daar bevindt zich

53
00:04:20,000 --> 00:04:25,000
een prachtige dieprode kristallaar. En laat jouw wortels zich daar

54
00:04:25,000 --> 00:04:30,000
maar stevig in verankeren. En laat jouw voetwortels zich daar

55
00:04:30,000 --> 00:04:35,000
maar stevig in verankeren. En laat jouw wortels zich daar

56
00:04:35,000 --> 00:04:40,000
maar stevig in verankeren. Zet ze maar stevig vast. En

57
00:04:40,000 --> 00:04:45,000
alles wat jou nu niet dient, gedachten, twijfels, onrust, emoties,

58
00:04:45,000 --> 00:04:50,000
verwachtingen, alle toedo's, laat ze via jouw voetwortels maar naar

59
00:04:50,000 --> 00:04:55,000
die kristallaar stromen. Laat het maar los. Je hebt het

60
00:04:55,000 --> 00:05:00,000
nu even niet nodig en de aarde neemt het moeiteloos

61
00:05:00,000 --> 00:05:05,000
van je aan. En voel dan hoe er vanuit deze

62
00:05:05,000 --> 00:05:10,000
kristallaar een stroom van dieprode energie via jouw voetwortels omhoog

63
00:05:10,000 --> 00:05:15,000
stroomt, richting je voeten. Dit is de energie van veiligheid,

64
00:05:15,000 --> 00:05:20,000
geborgenheid, stevigheid. De energie van onrust, de energie van ondersteuning

65
00:05:20,000 --> 00:05:25,000
en fundament. En vanuit je voeten stroomt deze energie dan

66
00:05:25,000 --> 00:05:30,000
ook verder omhoog je lichaam in. Vanuit je voeten via

67
00:05:30,000 --> 00:05:35,000
je enkels, je benen, je bekken en dan ook verder

68
00:05:35,000 --> 00:05:40,000
naar je buik, je rug, je borst en je schouderbladen.

69
00:05:40,000 --> 00:05:45,000
En vanuit je schouders stroomt deze energie je armen in,

70
00:05:45,000 --> 00:05:50,000
richting je polsen en je handen tot in de topjes

71
00:05:50,000 --> 00:05:55,000
van je vingers. En dan ook vanuit je schouders verder

72
00:05:55,000 --> 00:06:00,000
omhoog, richting je nek en hals, verder door naar je

73
00:06:00,000 --> 00:06:05,000
gezicht. En voel hoe deze liefdevolle, veilige, stevige energie verder

74
00:06:05,000 --> 00:06:10,000
omhoog wervelt, langs je kin, je wangen, neus, oren, ogen,

75
00:06:10,000 --> 00:06:15,000
voorhoofd, de achterkant van je hoofd helemaal tot het puntje

76
00:06:15,000 --> 00:06:20,000
van je kruin. En vanuit je kruin kun je deze

77
00:06:20,000 --> 00:06:25,000
energie als een lijn verder laten stromen, omhoog, voorbij wolken,

78
00:06:25,000 --> 00:06:30,000
voorbij sterren en planeten, totdat je die plek in het

79
00:06:30,000 --> 00:06:35,000
universum vindt waar je jouw lijn mee wil verbinden. Zoek

80
00:06:35,000 --> 00:06:40,000
de mooiste, lichtste, fijnste plek maar uit en veranker jouw

81
00:06:40,000 --> 00:06:45,000
lijn daar. En voel dan hoe je nu staat, met

82
00:06:45,000 --> 00:06:50,000
die lijn van de energie door je heen stromend, diep

83
00:06:50,000 --> 00:06:55,000
geworteld door je hoofd, diep geworteld in de aarde en

84
00:06:55,000 --> 00:07:00,000
stevig verankerd in het universum. Jouw lichaam, jouw voertuig, jouw

85
00:07:00,000 --> 00:07:05,000
instrument, stevig, veilig en goed geaard. En maak dan weer

86
00:07:05,000 --> 00:07:10,000
contact met je ademhaling en voel dan langzaam je lichaam

87
00:07:10,000 --> 00:07:15,000
weer in de ruimte. Beweeg een beetje met je vingers

88
00:07:15,000 --> 00:07:20,000
en met je tenen en als je zover bent, open

89
00:07:20,000 --> 00:07:25,000
dan rustig weer je ogen en laat je lichaam weer

90
00:07:25,000 --> 00:11:44,020
in de ruimte.`;

export const MEDITATIONS_WITH_TRANSCRIPTS = {
  'de-lente': {
    title: 'De Lente',
    description:
      'Een verfrissende lente meditatie die je helpt om te verbinden met de vernieuwende energie van het seizoen. Ervaar hoe de natuur ontwaakt en laat deze energie je inspireren.',
    imageUrl:
      'https://images.unsplash.com/photo-1490750967868-88aa4486c946?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Welkom bij deze lente meditatie. Een moment om te verbinden

2
00:00:05,000 --> 00:00:10,000
met de vernieuwende energie van het seizoen. Neem een comfortabele

3
00:00:10,000 --> 00:00:15,000
positie in en sluit je ogen. Adem diep in door

4
00:00:15,000 --> 00:00:20,000
je neus, en langzaam uit door je mond. Voel hoe

5
00:00:20,000 --> 00:00:25,000
met elke ademhaling je lichaam meer ontspant. Stel je voor

6
00:00:25,000 --> 00:00:30,000
dat je in een prachtige lentetuin staat. De zon verwarmt

7
00:00:30,000 --> 00:00:35,000
zachtjes je huid. Je hoort vogels zingen en voelt een

8
00:00:35,000 --> 00:00:40,000
milde bries die de geur van bloesem met zich meebrengt...
`,
  },
  'veiligheid-aarding': {
    title: 'Aarden & Verbinding',
    description:
      'Deze meditatie helpt je om je veilig en geaard te voelen in je lichaam. Door middel van visualisatie en ademhalingsoefeningen creëer je een sterke verbinding met de aarde en je eigen lichaam.',
    imageUrl:
      'https://images.unsplash.com/photo-1506126613408-eca07ce68773?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Deze meditatie kan je helpen om je lichaam beter te

2
00:00:05,000 --> 00:00:10,000
voelen en onbewust te gronden, zodat je stevig met beide

3
00:00:10,000 --> 00:00:15,000
benen op de grond staat, weer terugkomt in dit moment

4
00:00:15,000 --> 00:00:20,000
en vanuit verbinding met jezelf weer verder kunt. Doe deze

5
00:00:20,000 --> 00:00:25,000
oefening bij voorkeur op blote voeten of met sokken aan.

6
00:00:25,000 --> 00:00:30,000
Ga staan of zitten in een gemakkelijke houding. En focus

7
00:00:30,000 --> 00:00:35,000
dan op je ademhaling. In door je neus en uit

8
00:00:35,000 --> 00:00:40,000
door je mond. En met elke inademing haal je je

9
00:00:40,000 --> 00:00:45,000
aandacht een beetje meer weg uit de buitenwereld. En verleg

10
00:00:45,000 --> 00:00:50,000
je deze meer en meer naar binnen in. En laat

11
00:00:50,000 --> 00:00:55,000
met elke uitademing meer en meer los wat je nu,

12
00:00:55,000 --> 00:01:00,000
in dit moment, niet dient. Daardoor krijgt je lichaam de

13
00:01:00,000 --> 00:01:05,000
kans om met elke ademhaling een beetje meer te ontspannen.

14
00:01:05,000 --> 00:01:10,000
Dus adem maar eens diep in. En uit. En doe

15
00:01:10,000 --> 00:01:15,000
dat nog maar een keer. In door je neus en

16
00:01:15,000 --> 00:01:20,000
uit door je mond. In en uit. En ga met

17
00:01:20,000 --> 00:01:25,000
je aandacht naar je hoofd. Breng je kin naar je

18
00:01:25,000 --> 00:01:30,000
borst. En draai je hoofd in een cirkelbeweging langzaam richting

19
00:01:30,000 --> 00:01:35,000
je rechter schouder. Naar achteren. Verder naar je linkerschouder. En

20
00:01:35,000 --> 00:01:40,000
weer naar voren. Met je kin naar je borst. En

21
00:01:40,000 --> 00:01:45,000
herhaal dit een paar keer in je eigen tempo. Je

22
00:01:45,000 --> 00:01:50,000
hoeft niet te forceren. Hou het rustig en wees vriendelijk

23
00:01:50,000 --> 00:01:55,000
voor je lichaam. En verander nu van richting. En draai

24
00:01:55,000 --> 00:02:00,000
je hoofd naar links. Naar achteren. Richting je rechterschouder. Kin

25
00:02:00,000 --> 00:02:05,000
op de borst. En doe dat nog maar een keer.

26
00:02:05,000 --> 00:02:10,000
En rol vervolgens even met je schouders. Naar voren. Naar

27
00:02:10,000 --> 00:02:15,000
achteren. Naar achteren. Naar achteren. Naar achteren. Naar achteren. Naar

28
00:02:15,000 --> 00:02:20,000
achteren. Naar achteren. En ook even de andere kant op.

29
00:02:20,000 --> 00:02:25,000
Hol je schouders maar naar achteren. En als je lichaam

30
00:02:25,000 --> 00:02:30,000
het toelaat, dan kun je ook de rest van je

31
00:02:30,000 --> 00:02:35,000
bovenlichaam een ronddraaiende beweging laten maken. In de vorm van

32
00:02:35,000 --> 00:02:40,000
een acht. Dus draai je bovenlichaam linksom. En vervolgens rechtsom.

33
00:02:40,000 --> 00:02:45,000
Dan weer linksom. En ga maar even zo door. En

34
00:02:45,000 --> 00:02:50,000
breng dan je lichaam weer tot stilstand. En word je

35
00:02:50,000 --> 00:02:55,000
bewust van je voeten op de vloer. En ga dan

36
00:02:55,000 --> 00:03:00,000
weer linksom. En vervolgens rechtsom. En vervolgens linksom. En vervolgens

37
00:03:00,000 --> 00:03:05,000
linksom. En vervolgens linksom. En vervolgens linksom. Danprised jaar ammer

38
00:03:05,000 --> 00:03:10,000
buiten. Helmaal terug. Vist, ow, licht in de moed. Elk

39
00:03:10,000 --> 00:03:15,000
onderdeel van je voet, overal met je handen en de

40
00:03:15,000 --> 00:03:20,000
tand op die maag. En dan word je weer linksom.

41
00:03:20,000 --> 00:03:25,000
Naar het midden. Naar achteren. Heel rustig. Dan weer terug

42
00:03:25,000 --> 00:03:30,000
naar het midden. En naar voren. Beweeg met aandacht. En

43
00:03:30,000 --> 00:03:35,000
van voren ga je via de bal van je voet

44
00:03:35,000 --> 00:03:40,000
weer naar het midden. En dan verder naar achteren. En

45
00:03:40,000 --> 00:03:45,000
weer terug. En stel je dan voor dat er vanuit

46
00:03:45,000 --> 00:03:50,000
je voeten een soort van boomwortels de aarde ingroeien. Misschien

47
00:03:50,000 --> 00:03:55,000
is dit één wortel of misschien zijn het er een

48
00:03:55,000 --> 00:04:00,000
heleboel. En laat die wortels maar dieper en dieper de

49
00:04:00,000 --> 00:04:05,000
aarde ingroeien. Voorbij zand en grind en stroompjes water. En

50
00:04:05,000 --> 00:04:10,000
hoe dieper jouw wortels de aarde ingroeien, hoe steviger en

51
00:04:10,000 --> 00:04:15,000
hoe meer gegrond jij je voelt. En dan bereiken jouw

52
00:04:15,000 --> 00:04:20,000
voetwortels het middelpunt van de aarde. En daar bevindt zich

53
00:04:20,000 --> 00:04:25,000
een prachtige dieprode kristallaar. En laat jouw wortels zich daar

54
00:04:25,000 --> 00:04:30,000
maar stevig in verankeren. En laat jouw voetwortels zich daar

55
00:04:30,000 --> 00:04:35,000
maar stevig in verankeren. En laat jouw wortels zich daar

56
00:04:35,000 --> 00:04:40,000
maar stevig in verankeren. Zet ze maar stevig vast. En

57
00:04:40,000 --> 00:04:45,000
alles wat jou nu niet dient, gedachten, twijfels, onrust, emoties,

58
00:04:45,000 --> 00:04:50,000
verwachtingen, alle toedo's, laat ze via jouw voetwortels maar naar

59
00:04:50,000 --> 00:04:55,000
die kristallaar stromen. Laat het maar los. Je hebt het

60
00:04:55,000 --> 00:05:00,000
nu even niet nodig en de aarde neemt het moeiteloos

61
00:05:00,000 --> 00:05:05,000
van je aan. En voel dan hoe er vanuit deze

62
00:05:05,000 --> 00:05:10,000
kristallaar een stroom van dieprode energie via jouw voetwortels omhoog

63
00:05:10,000 --> 00:05:15,000
stroomt, richting je voeten. Dit is de energie van veiligheid,

64
00:05:15,000 --> 00:05:20,000
geborgenheid, stevigheid. De energie van onrust, de energie van ondersteuning

65
00:05:20,000 --> 00:05:25,000
en fundament. En vanuit je voeten stroomt deze energie dan

66
00:05:25,000 --> 00:05:30,000
ook verder omhoog je lichaam in. Vanuit je voeten via

67
00:05:30,000 --> 00:05:35,000
je enkels, je benen, je bekken en dan ook verder

68
00:05:35,000 --> 00:05:40,000
naar je buik, je rug, je borst en je schouderbladen.

69
00:05:40,000 --> 00:05:45,000
En vanuit je schouders stroomt deze energie je armen in,

70
00:05:45,000 --> 00:05:50,000
richting je polsen en je handen tot in de topjes

71
00:05:50,000 --> 00:05:55,000
van je vingers. En dan ook vanuit je schouders verder

72
00:05:55,000 --> 00:06:00,000
omhoog, richting je nek en hals, verder door naar je

73
00:06:00,000 --> 00:06:05,000
gezicht. En voel hoe deze liefdevolle, veilige, stevige energie verder

74
00:06:05,000 --> 00:06:10,000
omhoog wervelt, langs je kin, je wangen, neus, oren, ogen,

75
00:06:10,000 --> 00:06:15,000
voorhoofd, de achterkant van je hoofd helemaal tot het puntje

76
00:06:15,000 --> 00:06:20,000
van je kruin. En vanuit je kruin kun je deze

77
00:06:20,000 --> 00:06:25,000
energie als een lijn verder laten stromen, omhoog, voorbij wolken,

78
00:06:25,000 --> 00:06:30,000
voorbij sterren en planeten, totdat je die plek in het

79
00:06:30,000 --> 00:06:35,000
universum vindt waar je jouw lijn mee wil verbinden. Zoek

80
00:06:35,000 --> 00:06:40,000
de mooiste, lichtste, fijnste plek maar uit en veranker jouw

81
00:06:40,000 --> 00:06:45,000
lijn daar. En voel dan hoe je nu staat, met

82
00:06:45,000 --> 00:06:50,000
die lijn van de energie door je heen stromend, diep

83
00:06:50,000 --> 00:06:55,000
geworteld door je hoofd, diep geworteld in de aarde en

84
00:06:55,000 --> 00:07:00,000
stevig verankerd in het universum. Jouw lichaam, jouw voertuig, jouw

85
00:07:00,000 --> 00:07:05,000
instrument, stevig, veilig en goed geaard. En maak dan weer

86
00:07:05,000 --> 00:07:10,000
contact met je ademhaling en voel dan langzaam je lichaam

87
00:07:10,000 --> 00:07:15,000
weer in de ruimte. Beweeg een beetje met je vingers

88
00:07:15,000 --> 00:07:20,000
en met je tenen en als je zover bent, open

89
00:07:20,000 --> 00:07:25,000
dan rustig weer je ogen en laat je lichaam weer

90
00:07:25,000 --> 00:11:44,020
in de ruimte.`,
  },
  'rust-minder-stress': {
    title: 'Rust & Minder Stress',
    description:
      'Een meditatie om stress los te laten en innerlijke rust te vinden.',
    imageUrl:
      'https://images.unsplash.com/photo-1528164344705-47542687000d?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Welkom bij deze meditatie voor rust en minder stress...
`,
  },
  verbinding: {
    title: 'Verbinding',
    description: 'Vind een diepere verbinding met jezelf en anderen.',
    imageUrl:
      'https://images.unsplash.com/photo-1516714435131-44d6b64dc6a2?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Laat je meenemen in deze verbindende meditatie...
`,
  },
  liefde: {
    title: 'Liefde',
    description: 'Open je hart en ervaar meer liefde in je leven.',
    imageUrl:
      'https://images.unsplash.com/photo-1518609878373-06d740f60d8b?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Welkom bij deze hartopening meditatie...
`,
  },
  beweging: {
    title: 'Beweging',
    description: 'Een mindful bewegingsmeditatie voor lichaam en geest.',
    imageUrl:
      'https://images.unsplash.com/photo-1552196563-55cd4e45efb3?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Maak je klaar voor deze bewegingsmeditatie...
`,
  },
  ontspanning: {
    title: 'Ontspanning',
    description: 'Laat spanning los en vind diepe ontspanning.',
    imageUrl:
      'https://images.unsplash.com/photo-1515377905703-c4788e51af15?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Laat je meenemen in deze ontspannende reis...
`,
  },
  energie: {
    title: 'Energie',
    description: 'Laad jezelf op met positieve energie.',
    imageUrl:
      'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Welkom bij deze energieke meditatie...
`,
  },
  zingeving: {
    title: 'Zingeving',
    description: 'Ontdek meer betekenis en zingeving in je leven.',
    imageUrl:
      'https://images.unsplash.com/photo-1507238691740-187a5b1d37b8?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Laat je meenemen op deze zingevende reis...
`,
  },
  slaap: {
    title: 'Slaap',
    description: 'Ontspan je lichaam en geest voor een goede nachtrust.',
    imageUrl:
      'https://images.unsplash.com/photo-1471560090527-d1af5e4e6eb6?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Maak je klaar voor een rustgevende slaapmeditatie...
`,
  },
  'vreugde-plezier': {
    title: 'Vreugde & Plezier',
    description: 'Verbind je met vreugde en levenslust.',
    imageUrl:
      'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Welkom bij deze vrolijke meditatie...
`,
  },
  dankbaarheid: {
    title: 'Dankbaarheid',
    description: 'Cultiveer een gevoel van dankbaarheid en waardering.',
    imageUrl:
      'https://images.unsplash.com/photo-1519834785169-98be25ec3f84?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Laat je meenemen in deze dankbaarheidsmeditatie...
`,
  },
  'terug-naar-het-nu': {
    title: 'Terug naar het Nu',
    description: 'Kom terug in het huidige moment met mindfulness.',
    imageUrl:
      'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Welkom bij deze mindfulness meditatie...
`,
  },
  'in-zijn-blijven': {
    title: 'In Zijn Blijven',
    description:
      'Een diepgaande meditatie om in het moment te blijven en je verbinding met het zijn te versterken.',
    imageUrl:
      'https://images.unsplash.com/photo-1490730141103-6cac27aaab94?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Welkom bij deze meditatie over in zijn blijven...
`,
  },
  'van-onrust-naar-rust': {
    title: 'Van Onrust naar Rust',
    description:
      'Een transformerende reis van innerlijke onrust naar diepe rust en vrede.',
    imageUrl:
      'https://images.unsplash.com/photo-1476611317561-60117649dd94?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Laat je meenemen op deze reis van onrust naar rust...
`,
  },
  'het-kristal': {
    title: 'Het Kristal',
    description:
      'Een visualisatie met een kristal als focus voor helderheid en transformatie.',
    imageUrl:
      'https://images.unsplash.com/photo-1618677366787-9727aacca7ea?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Welkom bij de kristal meditatie...
`,
  },
  'reis-naar-de-maan': {
    title: 'Reis naar de Maan',
    description:
      'Een magische visualisatie reis naar de maan voor innerlijke wijsheid.',
    imageUrl:
      'https://images.unsplash.com/photo-1532693322450-2cb5c511067d?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Bereid je voor op een bijzondere reis naar de maan...
`,
  },
  'de-tuin-van-je-leven': {
    title: 'De Tuin van je Leven',
    description:
      'Visualiseer en verzorg de tuin van je leven voor persoonlijke groei.',
    imageUrl:
      'https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Welkom in de tuin van je leven...
`,
  },
  'de-schommel-van-het-universum': {
    title: 'De Schommel van het Universum',
    description: 'Een kosmische reis op de schommel van het universum.',
    imageUrl:
      'https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Laat je meenemen op de schommel van het universum...
`,
  },
  'de-lift': {
    title: 'De Lift',
    description:
      'Een transformerende reis in een magische lift naar verschillende niveaus van bewustzijn.',
    imageUrl:
      'https://images.unsplash.com/photo-1580537659466-0a9bfa916a54?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Stap in de lift voor een bijzondere reis...
`,
  },
  'de-kapel': {
    title: 'De Kapel',
    description:
      'Een spirituele reis naar een heilige kapel voor innerlijke vrede.',
    imageUrl:
      'https://images.unsplash.com/photo-1548625149-fc4a29cf7092?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Welkom bij de kapel meditatie...
`,
  },
  'de-tribe': {
    title: 'De Tribe',
    description:
      'Verbind je met je spirituele tribe en voel de kracht van gemeenschap.',
    imageUrl:
      'https://images.unsplash.com/photo-1461280360983-bd93eaa5051b?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Welkom bij de tribe meditatie...
`,
  },
  'de-leeuwenpoort-piramide': {
    title: 'De Leeuwenpoort Piramide',
    description:
      'Een krachtige reis door de leeuwenpoort en de mystieke piramide.',
    imageUrl:
      'https://images.unsplash.com/photo-1604537529428-15bcbeecfe4d?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Welkom bij de leeuwenpoort piramide meditatie...
`,
  },
  'op-vakantie-in-je-hart': {
    title: 'Op Vakantie in je Hart',
    description: 'Een ontspannende reis naar de vredige plek in je hart.',
    imageUrl:
      'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Laat je meenemen op vakantie in je hart...
`,
  },
  'een-open-hart': {
    title: 'Een Open Hart',
    description: 'Open je hart voor meer liefde, compassie en verbinding.',
    imageUrl:
      'https://images.unsplash.com/photo-1518709766631-a6a7f45921c3?q=80&w=1200',
    transcription: `1
00:00:00,000 --> 00:00:05,000
Welkom bij deze hartopening meditatie...
`,
  },
};

export const JOURNEY_MEDITATIONS = [
  {
    title: 'In zijn blijven',
    duration: '30 min',
    category: 'Journey',
    imageUrl:
      'https://images.unsplash.com/photo-1490730141103-6cac27aaab94?q=80&w=1200',
  },
  {
    title: 'Van Onrust naar Rust',
    duration: '35 min',
    category: 'Journey',
    imageUrl:
      'https://images.unsplash.com/photo-1476611317561-60117649dd94?q=80&w=1200',
  },
  {
    title: 'Het Kristal',
    duration: '40 min',
    category: 'Journey',
    imageUrl:
      'https://images.unsplash.com/photo-1618677366787-9727aacca7ea?q=80&w=1200',
  },
  {
    title: 'Reis naar de Maan',
    duration: '45 min',
    category: 'Journey',
    imageUrl:
      'https://images.unsplash.com/photo-1532693322450-2cb5c511067d?q=80&w=1200',
  },
  {
    title: 'De Tuin van je Leven',
    duration: '35 min',
    category: 'Journey',
    imageUrl:
      'https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?q=80&w=1200',
  },
  {
    title: 'De Schommel van het Universum',
    duration: '40 min',
    category: 'Journey',
    imageUrl:
      'https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?q=80&w=1200',
  },
  {
    title: 'De Lift',
    duration: '30 min',
    category: 'Journey',
    imageUrl:
      'https://images.unsplash.com/photo-1580537659466-0a9bfa916a54?q=80&w=1200',
  },
  {
    title: 'De Kapel',
    duration: '35 min',
    category: 'Journey',
    imageUrl:
      'https://images.unsplash.com/photo-1548625149-fc4a29cf7092?q=80&w=1200',
  },
  {
    title: 'De Tribe',
    duration: '45 min',
    category: 'Journey',
    imageUrl:
      'https://images.unsplash.com/photo-1461280360983-bd93eaa5051b?q=80&w=1200',
  },
  {
    title: 'De Leeuwenpoort Piramide',
    duration: '40 min',
    category: 'Journey',
    imageUrl:
      'https://images.unsplash.com/photo-1604537529428-15bcbeecfe4d?q=80&w=1200',
  },
  {
    title: 'Op Vakantie in je Hart',
    duration: '35 min',
    category: 'Journey',
    imageUrl:
      'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?q=80&w=1200',
  },
  {
    title: 'Een open Hart',
    duration: '30 min',
    category: 'Journey',
    imageUrl:
      'https://images.unsplash.com/photo-1518709766631-a6a7f45921c3?q=80&w=1200',
  },
];

export const BINAURAL_BEATS = [
  {
    title: 'Diepe Slaap',
    description: 'Ontspan je geest en val gemakkelijk in slaap',
    frequency: '4.5 Hz',
    category: 'Slaap',
    imageUrl:
      'https://images.unsplash.com/photo-1471560090527-d1af5e4e6eb6?q=80&w=1200',
    id: 'diepe-slaap',
  },
  {
    title: 'Optimale Alertheid',
    description: 'Verhoog je concentratie en mentale helderheid',
    frequency: '14 Hz',
    category: 'Focus',
    imageUrl:
      'https://images.unsplash.com/photo-1551836022-deb4988cc6c0?q=80&w=1200',
    id: 'optimale-alertheid',
  },
  {
    title: 'Van Angst naar Liefde',
    description: 'Transformeer angstige gevoelens naar innerlijke rust',
    frequency: '7.83 Hz',
    category: 'Emotioneel Welzijn',
    imageUrl:
      'https://images.unsplash.com/photo-1518241353330-0f7941c2d9b5?q=80&w=1200',
    id: 'van-angst-naar-liefde',
  },
  {
    title: 'Je Veilig Voelen',
    description: 'Creëer een gevoel van veiligheid en geborgenheid',
    frequency: '6.3 Hz',
    category: 'Veiligheid',
    imageUrl:
      'https://images.unsplash.com/photo-1444703686981-a3abbc4d4fe3?q=80&w=1200',
    id: 'je-veilig-voelen',
  },
  {
    title: 'Terug naar Rust',
    description: 'Herstel je innerlijke balans en kalmte',
    frequency: '10 Hz',
    category: 'Rust',
    imageUrl:
      'https://images.unsplash.com/photo-1475070929565-c985b496cb9f?q=80&w=1200',
    id: 'terug-naar-rust',
  },
  {
    title: 'Leegte vs Ruimte',
    description: 'Transformeer leegte naar ruimte voor nieuwe mogelijkheden',
    frequency: '8.5 Hz',
    category: 'Transformatie',
    imageUrl:
      'https://images.unsplash.com/photo-1534796636912-3b95b3ab5986?q=80&w=1200',
    id: 'leegte-vs-ruimte',
  },
  {
    title: 'Terug in je Lichaam',
    description: 'Versterk de verbinding tussen geest en lichaam',
    frequency: '7 Hz',
    category: 'Lichaamsverbinding',
    imageUrl:
      'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=1200',
    id: 'terug-in-je-lichaam',
  },
  {
    title: 'Van Leegte naar Ruimte',
    description: 'Creëer innerlijke ruimte voor groei en ontwikkeling',
    frequency: '9.6 Hz',
    category: 'Persoonlijke Groei',
    imageUrl:
      'https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=1200',
    id: 'van-leegte-naar-ruimte',
  },
  {
    title: 'Stemming van Mineur naar Majeur',
    description: 'Verhoog je stemming en emotioneel welzijn',
    frequency: '12 Hz',
    category: 'Stemming',
    imageUrl:
      'https://images.unsplash.com/photo-1459749411175-04bf5292ceea?q=80&w=1200',
    id: 'stemming-van-mineur-naar-majeur',
  },
  {
    title: 'Balans Terug naar het Midden',
    description: 'Herstel evenwicht tussen lichaam en geest',
    frequency: '8 Hz',
    category: 'Balans',
    imageUrl:
      'https://images.unsplash.com/photo-1506126613408-eca07ce68773?q=80&w=1200',
    id: 'balans-terug-naar-het-midden',
  },
  {
    title: 'Van Hoofd naar Hart',
    description: 'Verbind je rationele denken met je emotionele hart',
    frequency: '5.5 Hz',
    category: 'Verbinding',
    imageUrl:
      'https://images.unsplash.com/photo-1519834785169-98be25ec3f84?q=80&w=1200',
    id: 'van-hoofd-naar-hart',
  },
  {
    title: 'Diepe Meditatie',
    description: 'Bereik een staat van diepe meditatie en innerlijke stilte',
    frequency: '3.5 Hz',
    category: 'Meditatie',
    imageUrl:
      'https://images.unsplash.com/photo-1508672019048-805c876b67e2?q=80&w=1200',
    id: 'diepe-meditatie',
  },
];

const BINAURAL_BEATS2 = {
  'diepe-slaap': {
    title: 'Diepe Slaap',
    description:
      'Een binaural beat die je helpt om in een diepe, herstellende slaap te komen.',
    imageUrl:
      'https://images.unsplash.com/photo-1471560090527-d1af5e4e6eb6?q=80&w=1200',
    audioUrl:
      'https://www.dropbox.com/scl/fi/i801ry2jievbxqkwabbwo/13.-We-Had-A-Good-Run.mp3?rlkey=pxno5pg786e90n8t6idf1p131&dl=1',
  },
  'optimale-alertheid': {
    title: 'Optimale Alertheid',
    description:
      'Verhoog je focus en mentale helderheid met deze energieke binaural beat.',
    imageUrl:
      'https://images.unsplash.com/photo-1551836022-deb4988cc6c0?q=80&w=1200',
    audioUrl:
      'https://www.dropbox.com/scl/fi/i801ry2jievbxqkwabbwo/13.-We-Had-A-Good-Run.mp3?rlkey=pxno5pg786e90n8t6idf1p131&dl=1',
  },
  'van-angst-naar-liefde': {
    title: 'Van Angst naar Liefde',
    description:
      'Een binaural beat die je helpt transformeren van angst naar een staat van liefde en vertrouwen.',
    imageUrl:
      'https://images.unsplash.com/photo-1518241353330-0f7941c2d9b5?q=80&w=1200',
    audioUrl:
      'https://www.dropbox.com/scl/fi/i801ry2jievbxqkwabbwo/13.-We-Had-A-Good-Run.mp3?rlkey=pxno5pg786e90n8t6idf1p131&dl=1',
  },
  'je-veilig-voelen': {
    title: 'Je Veilig Voelen',
    description:
      'Creëer een gevoel van veiligheid en geborgenheid met deze kalmerende frequenties.',
    imageUrl:
      'https://images.unsplash.com/photo-1444703686981-a3abbc4d4fe3?q=80&w=1200',
    audioUrl:
      'https://www.dropbox.com/scl/fi/i801ry2jievbxqkwabbwo/13.-We-Had-A-Good-Run.mp3?rlkey=pxno5pg786e90n8t6idf1p131&dl=1',
  },
  'terug-naar-rust': {
    title: 'Terug naar Rust',
    description:
      'Herstel je innerlijke balans en vind diepe rust met deze binaural beat.',
    imageUrl:
      'https://images.unsplash.com/photo-1475070929565-c985b496cb9f?q=80&w=1200',
    audioUrl:
      'https://www.dropbox.com/scl/fi/i801ry2jievbxqkwabbwo/13.-We-Had-A-Good-Run.mp3?rlkey=pxno5pg786e90n8t6idf1p131&dl=1',
  },
  'leegte-vs-ruimte': {
    title: 'Leegte vs Ruimte',
    description:
      'Transformeer gevoelens van leegte naar ruimte en mogelijkheden.',
    imageUrl:
      'https://images.unsplash.com/photo-1534796636912-3b95b3ab5986?q=80&w=1200',
    audioUrl:
      'https://www.dropbox.com/scl/fi/i801ry2jievbxqkwabbwo/13.-We-Had-A-Good-Run.mp3?rlkey=pxno5pg786e90n8t6idf1p131&dl=1',
  },
  'terug-in-je-lichaam': {
    title: 'Terug in je Lichaam',
    description:
      'Versterk de verbinding met je lichaam en voel je weer helemaal aanwezig.',
    imageUrl:
      'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=1200',
    audioUrl:
      'https://www.dropbox.com/scl/fi/i801ry2jievbxqkwabbwo/13.-We-Had-A-Good-Run.mp3?rlkey=pxno5pg786e90n8t6idf1p131&dl=1',
  },
  'van-leegte-naar-ruimte': {
    title: 'Van Leegte naar Ruimte',
    description:
      'Ontdek de oneindige mogelijkheden in de ruimte die leegte biedt.',
    imageUrl:
      'https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=1200',
    audioUrl:
      'https://www.dropbox.com/scl/fi/i801ry2jievbxqkwabbwo/13.-We-Had-A-Good-Run.mp3?rlkey=pxno5pg786e90n8t6idf1p131&dl=1',
  },
  'stemming-van-mineur-naar-majeur': {
    title: 'Stemming van Mineur naar Majeur',
    description:
      'Verhoog je stemming en transformeer negatieve emoties naar positieve.',
    imageUrl:
      'https://images.unsplash.com/photo-1459749411175-04bf5292ceea?q=80&w=1200',
    audioUrl:
      'https://www.dropbox.com/scl/fi/i801ry2jievbxqkwabbwo/13.-We-Had-A-Good-Run.mp3?rlkey=pxno5pg786e90n8t6idf1p131&dl=1',
  },
  'balans-terug-naar-het-midden': {
    title: 'Balans Terug naar het Midden',
    description: 'Herstel je natuurlijke balans en vind je centrum terug.',
    imageUrl:
      'https://images.unsplash.com/photo-1506126613408-eca07ce68773?q=80&w=1200',
    audioUrl:
      'https://www.dropbox.com/scl/fi/i801ry2jievbxqkwabbwo/13.-We-Had-A-Good-Run.mp3?rlkey=pxno5pg786e90n8t6idf1p131&dl=1',
  },
  'van-hoofd-naar-hart': {
    title: 'Van Hoofd naar Hart',
    description: 'Maak de reis van mentale activiteit naar hartbewustzijn.',
    imageUrl:
      'https://images.unsplash.com/photo-1519834785169-98be25ec3f84?q=80&w=1200',
    audioUrl:
      'https://www.dropbox.com/scl/fi/i801ry2jievbxqkwabbwo/13.-We-Had-A-Good-Run.mp3?rlkey=pxno5pg786e90n8t6idf1p131&dl=1',
  },
};

// MARK: quote
export const QUOTE_OF_THE_DAY = {
  quote: 'Elke dag is een nieuwe kans om te groeien',
  author: 'Hoofd naar Hart',
  imageUrl:
    'https://images.unsplash.com/photo-1519834785169-98be25ec3f84?q=80&w=1200',
};
